import { render, staticRenderFns } from "./super_home.vue?vue&type=template&id=597a14be&"
import script from "./super_home.vue?vue&type=script&lang=js&"
export * from "./super_home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports